/* global G */
/* eslint-disable object-curly-newline,arrow-body-style,no-unused-vars */
import stepper from 'app/_shared/action/stepper'
import { asyncPipeSpread, setKey } from 'lib/util'
import sequenceComponentFind from 'lib/sequence/component/children/find'
import seqModelRead from 'lib/sequence/model/api/read'
import sequenceComponentState from 'lib/sequence/component/state'
import { CONFIRM } from 'app/_shared/events/setStepTab'
import device from './create/device'
import location from './create/location'
import information from './create/information'
import partner from './create/partner'
import finish from './create/finish'

const {
  set: setTab,
} = sequenceComponentState('activeTab')

const setConfirmTab = step => setTab(step, CONFIRM)

/**
 * Presets the item step if available.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export const presetLocation = module => component => async (children, ...args) => {
  const { organisation } = args[0] || {}

  if (organisation) {
    const model = module[G.MODEL]
    model[G.CHILDREN].installedAt[G.CACHE] = organisation[G.CACHE]
    model[G.CHILDREN].installedAt[G.STATE][G.REF] = organisation[G.STATE][G.REF]

    await seqModelRead(model[G.CHILDREN].installedAt)(component)

    setConfirmTab(children.location)
  }

  return [children, ...args]
}

/**
 * Presets the `model` to the incoming `item`, if available.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
const presetModel = module => component => async (children, ...args) => {
  const { item } = args[0] || {}

  const { _rev = '' } = item?.[G.CACHE] || {}
  const isEquipment = _rev.split('-')?.[0] === '0'

  if (isEquipment) {
    const model = module[G.MODEL]

    model[G.CACHE] = item[G.CACHE]
    model[G.STATE][G.REF] = item[G.STATE][G.REF]
    model[G.STATE].syntheticKey = item[G.STATE][G.REF]

    await seqModelRead(model)(component)
    setConfirmTab(children.device)
  }

  return [children, ...args]
}

/**
 * Gathers the actions for the stepper.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
const initActions = module => component => async (...args) => [
  { device, location, information, partner, finish }, args,
]

/**
 * Initializes the stepper.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
const initStepper = module => component => async (actions, ...args) => {
  return await stepper(module)(component)({ actions, ...args })
}

export default module => component => async (...args) => asyncPipeSpread(
  presetModel(module)(component),
  presetLocation(module)(component),
  initActions(module)(component),
  initStepper(module)(component),
)(sequenceComponentFind(component), ...args)
